var _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _line36, _line37, _line38, _line39, _line40, _line41, _line42, _line43, _line44, _line45, _line46, _line47, _line48, _line49, _line50, _line51, _line52, _line53, _line54, _line55, _line56, _line57, _line58, _line59, _line60, _line61, _line62, _line63, _line64, _line65, _line66, _line67, _line68, _line69, _line70, _line71, _line72, _line73, _line74, _line75, _line76, _line77, _line78, _line79, _line80, _line81, _line82, _line83, _line84, _line85, _line86, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _line87, _line88, _line89, _line90, _line91, _line92, _line93, _line94, _line95, _line96, _line97, _line98, _line99, _line100, _line101, _line102, _line103, _line104, _line105, _line106, _line107, _line108, _line109, _line110, _line111, _line112;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFefco217 = function SvgFefco217(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "815.0mm",
    height: "411.43306481411867mm",
    viewBox: "0.0 3.5185881375715544e-05 815.0 411.43306481411867",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 16.5,
    x2: 16.5,
    y1: 170.76642772207322,
    y2: 73.76642772207323,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 16.5,
    x2: 16.5,
    y1: 73.76642772207323,
    y2: 3.766427722073229,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 56.8125,
    x2: 40.550248076566106,
    y1: 21.266427722073228,
    y2: 6.354835968381377,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 70.25,
    x2: 56.8125,
    y1: 3.766427722073229,
    y2: 21.266427722073228,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 70.25,
    x2: 159.75,
    y1: 3.766427722073229,
    y2: 3.766427722073229,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 159.75,
    x2: 173.1875,
    y1: 3.766427722073229,
    y2: 21.266427722073228,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 173.1875,
    x2: 189.4497519234339,
    y1: 21.266427722073228,
    y2: 6.354835968381377,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 213.5,
    x2: 213.5,
    y1: 73.76642772207323,
    y2: 3.766427722073229,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 213.5,
    x2: 213.5,
    y1: 170.76642772207322,
    y2: 73.76642772207323,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 213.5,
    x2: 215,
    y1: 170.76642772207322,
    y2: 170.76642772207322,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 215,
    x2: 310.5,
    y1: 170.76642772207322,
    y2: 84.35483596838141,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 415,
    x2: 319.5,
    y1: 170.76642772207322,
    y2: 84.35483596838141,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 416.5,
    x2: 415,
    y1: 170.76642772207322,
    y2: 170.76642772207322,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 416.5,
    x2: 416.5,
    y1: 170.76642772207322,
    y2: 73.76642772207323,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 416.5,
    x2: 416.5,
    y1: 3.766427722073229,
    y2: 73.76642772207323,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 456.81250000000006,
    x2: 470.25000000000006,
    y1: 21.266427722073228,
    y2: 3.766427722073229,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 470.25000000000006,
    x2: 559.75,
    y1: 3.766427722073229,
    y2: 3.766427722073229,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 573.1875,
    x2: 559.75,
    y1: 21.266427722073228,
    y2: 3.766427722073229,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 456.81250000000006,
    x2: 440.55024807656616,
    y1: 21.266427722073228,
    y2: 6.354835968381377,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 573.1875,
    x2: 589.4497519234338,
    y1: 21.266427722073228,
    y2: 6.354835968381377,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 613.5,
    x2: 613.5,
    y1: 3.766427722073229,
    y2: 73.76642772207323,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 613.5,
    x2: 613.5,
    y1: 170.76642772207322,
    y2: 73.76642772207323,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 613.5,
    x2: 615,
    y1: 170.76642772207322,
    y2: 170.76642772207322,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    x1: 615,
    x2: 710.5,
    y1: 170.76642772207322,
    y2: 84.35483596838141,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    x1: 815,
    x2: 719.5,
    y1: 167.76642772207322,
    y2: 84.35483596838141,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    x1: 815,
    x2: 815,
    y1: 170.76642772207322,
    y2: 167.76642772207322,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    x1: 717.25,
    x2: 712.75,
    y1: 104.35483596838141,
    y2: 104.35483596838141,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    x1: 717.25,
    x2: 717.25,
    y1: 170.76642772207322,
    y2: 104.35483596838141,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    x1: 712.75,
    x2: 712.75,
    y1: 170.76642772207322,
    y2: 104.35483596838141,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    x1: 712.75,
    x2: 717.25,
    y1: 170.76642772207322,
    y2: 170.76642772207322,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    x1: 815,
    x2: 815,
    y1: 170.76642772207322,
    y2: 276.7664277220733,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    x1: 815,
    x2: 810.5,
    y1: 276.7664277220733,
    y2: 279.7664277220733,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    x1: 810.5,
    x2: 712,
    y1: 279.7664277220733,
    y2: 330.5164277220733,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    x1: 712,
    x2: 714.5,
    y1: 330.5164277220733,
    y2: 361.4330943887399,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    x1: 619.5,
    x2: 712,
    y1: 365.1830943887399,
    y2: 365.1830943887399,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    x1: 616.5,
    x2: 619.5,
    y1: 279.7664277220733,
    y2: 365.1830943887399,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    x1: 615,
    x2: 616.5,
    y1: 279.7664277220733,
    y2: 279.7664277220733,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    x1: 613.5,
    x2: 615,
    y1: 279.7664277220733,
    y2: 279.7664277220733,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    x1: 611.25,
    x2: 613.5,
    y1: 282.7664277220733,
    y2: 279.7664277220733,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    x1: 611.25,
    x2: 564.25,
    y1: 282.7664277220733,
    y2: 382.7664277220733,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    x1: 564.25,
    x2: 564.25,
    y1: 382.7664277220733,
    y2: 406.4330943887399,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    x1: 559.25,
    x2: 470.75000000000006,
    y1: 411.4330943887399,
    y2: 411.4330943887399,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    x1: 465.75,
    x2: 465.75,
    y1: 382.7664277220733,
    y2: 406.4330943887399,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    x1: 418.75,
    x2: 465.75,
    y1: 282.7664277220733,
    y2: 382.7664277220733,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    x1: 416.5,
    x2: 418.75,
    y1: 279.7664277220733,
    y2: 282.7664277220733,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
    x1: 415,
    x2: 416.5,
    y1: 279.7664277220733,
    y2: 279.7664277220733,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line47 || (_line47 = /*#__PURE__*/React.createElement("line", {
    x1: 413.5,
    x2: 415,
    y1: 279.7664277220733,
    y2: 279.7664277220733,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line48 || (_line48 = /*#__PURE__*/React.createElement("line", {
    x1: 413.5,
    x2: 410.5,
    y1: 279.7664277220733,
    y2: 365.1830943887399,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line49 || (_line49 = /*#__PURE__*/React.createElement("line", {
    x1: 410.5,
    x2: 319.5,
    y1: 365.1830943887399,
    y2: 365.1830943887399,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line50 || (_line50 = /*#__PURE__*/React.createElement("line", {
    x1: 319.5,
    x2: 317,
    y1: 330.5164277220733,
    y2: 361.4330943887399,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line51 || (_line51 = /*#__PURE__*/React.createElement("line", {
    x1: 221,
    x2: 319.5,
    y1: 279.7664277220733,
    y2: 330.5164277220733,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line52 || (_line52 = /*#__PURE__*/React.createElement("line", {
    x1: 213.5,
    x2: 215,
    y1: 276.7664277220733,
    y2: 276.7664277220733,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line53 || (_line53 = /*#__PURE__*/React.createElement("line", {
    x1: 218,
    x2: 215,
    y1: 276.7664277220733,
    y2: 276.7664277220733,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line54 || (_line54 = /*#__PURE__*/React.createElement("line", {
    x1: 221,
    x2: 218,
    y1: 279.7664277220733,
    y2: 276.7664277220733,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line55 || (_line55 = /*#__PURE__*/React.createElement("line", {
    x1: 213.5,
    x2: 210.5,
    y1: 276.7664277220733,
    y2: 411.4330943887399,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line56 || (_line56 = /*#__PURE__*/React.createElement("line", {
    x1: 210.5,
    x2: 172.25,
    y1: 411.4330943887399,
    y2: 411.4330943887399,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line57 || (_line57 = /*#__PURE__*/React.createElement("line", {
    x1: 167.25,
    x2: 167.25,
    y1: 376.7664277220733,
    y2: 406.4330943887399,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line58 || (_line58 = /*#__PURE__*/React.createElement("line", {
    x1: 62.75,
    x2: 167.25,
    y1: 376.7664277220733,
    y2: 376.7664277220733,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line59 || (_line59 = /*#__PURE__*/React.createElement("line", {
    x1: 62.75,
    x2: 62.75,
    y1: 376.7664277220733,
    y2: 406.4330943887399,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line60 || (_line60 = /*#__PURE__*/React.createElement("line", {
    x1: 16.5,
    x2: 19.5,
    y1: 276.7664277220733,
    y2: 411.4330943887399,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line61 || (_line61 = /*#__PURE__*/React.createElement("line", {
    x1: 19.5,
    x2: 57.75,
    y1: 411.4330943887399,
    y2: 411.4330943887399,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line62 || (_line62 = /*#__PURE__*/React.createElement("line", {
    x1: 16.5,
    x2: 16.5,
    y1: 276.7664277220733,
    y2: 274.5164277220733,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line63 || (_line63 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    x2: 16.5,
    y1: 273.7664277220733,
    y2: 274.5164277220733,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line64 || (_line64 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    x2: 15,
    y1: 266.2664277220733,
    y2: 273.7664277220733,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line65 || (_line65 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    x2: 0,
    y1: 181.26642772207322,
    y2: 266.2664277220733,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line66 || (_line66 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    x2: 0,
    y1: 173.76642772207322,
    y2: 181.26642772207322,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line67 || (_line67 = /*#__PURE__*/React.createElement("line", {
    x1: 17.099999999999994,
    x2: 15,
    y1: 172.96642772207326,
    y2: 173.76642772207322,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line68 || (_line68 = /*#__PURE__*/React.createElement("line", {
    x1: 16.5,
    x2: 17.099999999999994,
    y1: 170.76642772207322,
    y2: 173.01642772207322,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line69 || (_line69 = /*#__PURE__*/React.createElement("line", {
    x1: 312.75,
    x2: 317.25,
    y1: 104.35483596838141,
    y2: 104.35483596838141,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line70 || (_line70 = /*#__PURE__*/React.createElement("line", {
    x1: 317.25,
    x2: 317.25,
    y1: 170.76642772207322,
    y2: 104.35483596838141,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line71 || (_line71 = /*#__PURE__*/React.createElement("line", {
    x1: 312.75,
    x2: 317.25,
    y1: 170.76642772207322,
    y2: 170.76642772207322,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line72 || (_line72 = /*#__PURE__*/React.createElement("line", {
    x1: 312.75,
    x2: 312.75,
    y1: 170.76642772207322,
    y2: 104.35483596838141,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line73 || (_line73 = /*#__PURE__*/React.createElement("line", {
    x1: 77.49999999999999,
    x2: 152.5,
    y1: 32.442898310308536,
    y2: 32.442898310308536,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line74 || (_line74 = /*#__PURE__*/React.createElement("line", {
    x1: 77.49999999999999,
    x2: 152.5,
    y1: 57.442898310308536,
    y2: 57.442898310308536,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line75 || (_line75 = /*#__PURE__*/React.createElement("line", {
    x1: 34.40909090909091,
    x2: 52.31818181818181,
    y1: 73.76642772207323,
    y2: 73.76642772207323,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line76 || (_line76 = /*#__PURE__*/React.createElement("line", {
    x1: 70.22727272727272,
    x2: 88.13636363636364,
    y1: 73.76642772207323,
    y2: 73.76642772207323,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line77 || (_line77 = /*#__PURE__*/React.createElement("line", {
    x1: 106.04545454545455,
    x2: 123.95454545454545,
    y1: 73.76642772207323,
    y2: 73.76642772207323,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line78 || (_line78 = /*#__PURE__*/React.createElement("line", {
    x1: 141.86363636363637,
    x2: 159.77272727272725,
    y1: 73.76642772207323,
    y2: 73.76642772207323,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line79 || (_line79 = /*#__PURE__*/React.createElement("line", {
    x1: 177.6818181818182,
    x2: 195.59090909090907,
    y1: 73.76642772207323,
    y2: 73.76642772207323,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line80 || (_line80 = /*#__PURE__*/React.createElement("line", {
    x1: 434.40909090909093,
    x2: 452.31818181818187,
    y1: 73.76642772207323,
    y2: 73.76642772207323,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line81 || (_line81 = /*#__PURE__*/React.createElement("line", {
    x1: 470.2272727272728,
    x2: 488.1363636363637,
    y1: 73.76642772207323,
    y2: 73.76642772207323,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line82 || (_line82 = /*#__PURE__*/React.createElement("line", {
    x1: 506.04545454545456,
    x2: 523.9545454545454,
    y1: 73.76642772207323,
    y2: 73.76642772207323,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line83 || (_line83 = /*#__PURE__*/React.createElement("line", {
    x1: 541.8636363636363,
    x2: 559.7727272727271,
    y1: 73.76642772207323,
    y2: 73.76642772207323,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line84 || (_line84 = /*#__PURE__*/React.createElement("line", {
    x1: 577.681818181818,
    x2: 595.5909090909089,
    y1: 73.76642772207323,
    y2: 73.76642772207323,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line85 || (_line85 = /*#__PURE__*/React.createElement("line", {
    x1: 477.50000000000006,
    x2: 552.5,
    y1: 32.442898310308536,
    y2: 32.442898310308536,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line86 || (_line86 = /*#__PURE__*/React.createElement("line", {
    x1: 552.5,
    x2: 477.50000000000006,
    y1: 57.442898310308536,
    y2: 57.442898310308536,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5,
    d: "M 40.5502 6.3549 C 40.5502 -3.6451 16.5 3.7665 16.5 3.7665"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5,
    d: "M 77.5 32.4429 a 12.5 12.5 0 0 0 0 25"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5,
    d: "M 152.5 57.4429 a 12.5 12.5 0 0 0 0 -25"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5,
    d: "M 189.4498 6.3549 C 189.4498 -6.2335 213.5 3.7665 213.5 3.7665"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5,
    d: "M 310.5 84.3549 c 2.25 -2.25 6.75 -2.25 9 0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5,
    d: "M 477.5 32.4429 a 12.5 12.5 0 0 0 0 25"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5,
    d: "M 440.5502 6.3549 C 440.5502 -6.2335 416.5 3.7665 416.5 3.7665"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5,
    d: "M 552.5 57.4429 a 12.5 12.5 1 0 0 0 -25"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5,
    d: "M 589.4498 6.3549 C 589.4498 -6.2335 613.5 3.7665 613.5 3.7665"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5,
    d: "M 710.5 84.3549 c 2.25 -2.25 6.75 -2.25 9 0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5,
    d: "M 714.5 361.4331 C 715.125 363.0998 714.5 365.1831 712 365.1831"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5,
    d: "M 564.25 406.4331 c 0 3.3333 -1.6667 5 -5 5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5,
    d: "M 465.75 406.4331 c 0 3.3333 1.6667 5 5 5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5,
    d: "M 317 361.4331 C 316.375 363.0998 317 365.1831 319.5 365.1831"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5,
    d: "M 167.25 406.4331 c 0 3.3333 1.6667 5 5 5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5,
    d: "M 62.75 406.4331 c 0 3.3333 -1.6667 5 -5 5"
  })), _line87 || (_line87 = /*#__PURE__*/React.createElement("line", {
    x1: 16.5,
    x2: 34.40909090909091,
    y1: 73.76642772207323,
    y2: 73.76642772207323,
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 0.5
  })), _line88 || (_line88 = /*#__PURE__*/React.createElement("line", {
    x1: 52.31818181818181,
    x2: 70.22727272727272,
    y1: 73.76642772207323,
    y2: 73.76642772207323,
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 0.5
  })), _line89 || (_line89 = /*#__PURE__*/React.createElement("line", {
    x1: 88.13636363636364,
    x2: 106.04545454545455,
    y1: 73.76642772207323,
    y2: 73.76642772207323,
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 0.5
  })), _line90 || (_line90 = /*#__PURE__*/React.createElement("line", {
    x1: 123.95454545454545,
    x2: 141.86363636363637,
    y1: 73.76642772207323,
    y2: 73.76642772207323,
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 0.5
  })), _line91 || (_line91 = /*#__PURE__*/React.createElement("line", {
    x1: 159.77272727272725,
    x2: 177.6818181818182,
    y1: 73.76642772207323,
    y2: 73.76642772207323,
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 0.5
  })), _line92 || (_line92 = /*#__PURE__*/React.createElement("line", {
    x1: 195.59090909090907,
    x2: 213.5,
    y1: 73.76642772207323,
    y2: 73.76642772207323,
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 0.5
  })), _line93 || (_line93 = /*#__PURE__*/React.createElement("line", {
    x1: 213.5,
    x2: 16.5,
    y1: 170.76642772207322,
    y2: 170.76642772207322,
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 0.5
  })), _line94 || (_line94 = /*#__PURE__*/React.createElement("line", {
    x1: 416.5,
    x2: 434.40909090909093,
    y1: 73.76642772207323,
    y2: 73.76642772207323,
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 0.5
  })), _line95 || (_line95 = /*#__PURE__*/React.createElement("line", {
    x1: 452.31818181818187,
    x2: 470.2272727272728,
    y1: 73.76642772207323,
    y2: 73.76642772207323,
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 0.5
  })), _line96 || (_line96 = /*#__PURE__*/React.createElement("line", {
    x1: 488.1363636363637,
    x2: 506.04545454545456,
    y1: 73.76642772207323,
    y2: 73.76642772207323,
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 0.5
  })), _line97 || (_line97 = /*#__PURE__*/React.createElement("line", {
    x1: 523.9545454545454,
    x2: 541.8636363636363,
    y1: 73.76642772207323,
    y2: 73.76642772207323,
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 0.5
  })), _line98 || (_line98 = /*#__PURE__*/React.createElement("line", {
    x1: 559.7727272727271,
    x2: 577.681818181818,
    y1: 73.76642772207323,
    y2: 73.76642772207323,
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 0.5
  })), _line99 || (_line99 = /*#__PURE__*/React.createElement("line", {
    x1: 595.5909090909089,
    x2: 613.5,
    y1: 73.76642772207323,
    y2: 73.76642772207323,
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 0.5
  })), _line100 || (_line100 = /*#__PURE__*/React.createElement("line", {
    x1: 712.75,
    x2: 615,
    y1: 170.76642772207322,
    y2: 170.76642772207322,
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 0.5
  })), _line101 || (_line101 = /*#__PURE__*/React.createElement("line", {
    x1: 616.5,
    x2: 810.5,
    y1: 279.7664277220733,
    y2: 279.7664277220733,
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 0.5
  })), _line102 || (_line102 = /*#__PURE__*/React.createElement("line", {
    x1: 615,
    x2: 615,
    y1: 170.76642772207322,
    y2: 279.7664277220733,
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 0.5
  })), _line103 || (_line103 = /*#__PURE__*/React.createElement("line", {
    x1: 418.75,
    x2: 611.25,
    y1: 282.7664277220733,
    y2: 282.7664277220733,
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 0.5
  })), _line104 || (_line104 = /*#__PURE__*/React.createElement("line", {
    x1: 416.5,
    x2: 613.5,
    y1: 170.76642772207322,
    y2: 170.76642772207322,
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 0.5
  })), _line105 || (_line105 = /*#__PURE__*/React.createElement("line", {
    x1: 415,
    x2: 415,
    y1: 170.76642772207322,
    y2: 279.7664277220733,
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 0.5
  })), _line106 || (_line106 = /*#__PURE__*/React.createElement("line", {
    x1: 221,
    x2: 413.5,
    y1: 279.7664277220733,
    y2: 279.7664277220733,
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 0.5
  })), _line107 || (_line107 = /*#__PURE__*/React.createElement("line", {
    x1: 16.5,
    x2: 213.5,
    y1: 276.7664277220733,
    y2: 276.7664277220733,
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 0.5
  })), _line108 || (_line108 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    x2: 15,
    y1: 173.76642772207322,
    y2: 273.7664277220733,
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 0.5
  })), _line109 || (_line109 = /*#__PURE__*/React.createElement("line", {
    x1: 215,
    x2: 215,
    y1: 170.76642772207322,
    y2: 276.7664277220733,
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 0.5
  })), _line110 || (_line110 = /*#__PURE__*/React.createElement("line", {
    x1: 215,
    x2: 312.75,
    y1: 170.76642772207322,
    y2: 170.76642772207322,
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 0.5
  })), _line111 || (_line111 = /*#__PURE__*/React.createElement("line", {
    x1: 317.25,
    x2: 415,
    y1: 170.76642772207322,
    y2: 170.76642772207322,
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 0.5
  })), _line112 || (_line112 = /*#__PURE__*/React.createElement("line", {
    x1: 717.25,
    x2: 815,
    y1: 170.76642772207322,
    y2: 170.76642772207322,
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 0.5
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFefco217, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/fefco-217.5c910c39.svg";
export { ForwardRef as ReactComponent };